import type { ConstValues } from '../helpers.ts';
import type { ComparisonType } from './targetingValuesTypes.ts';

export const SelectRateOption = {
  VIEWABILITY_SCORE: 'viewability_score',
  VTR_SCORE: 'vtr_score',
} as const;
export type SelectRateOption = ConstValues<typeof SelectRateOption>;

export type SelectRateDataViewability = {
  [SelectRateOption.VIEWABILITY_SCORE]: {
    op: typeof ComparisonType.GREATER_THAN_OR_EQUAL_TO;
    val: string;
  };
};

export type SelectRateDataViewThroughRate = {
  [SelectRateOption.VTR_SCORE]: {
    op: typeof ComparisonType.GREATER_THAN_OR_EQUAL_TO;
    val: string;
  };
};

export type SelectRateFormState = {
  op: typeof ComparisonType.GREATER_THAN_OR_EQUAL_TO;
  val: string | null;
};
